export const minQuoteTokenAmount = 0;

export const minPositionSize = 0;

export const exerciseFee = 0.1;
